import { AnswerModel } from '../Question/AnswerModel';
import { FeatureModel, IFeature } from '../Feature/FeatureModel';
import { IExerciseModel } from '../Exercise/ExerciseModel';
import { IQuestionModel, QuestionModel } from '../Question/QuestionModel';
import { IRootStore } from '../Root/RootStore';
import { ISession, SessionModel } from '../Session/SessionModel';
import { ISessionStepModel, SessionStepModel } from '../Session/SessionStepModel';
import { ISurvey, Survey } from '../Survey/SurveyModel';
import { Instance, getRoot, tryReference, types } from 'mobx-state-tree';


export const DataRef = types
  .model('DataRef', {
    type: types.string,
    data: types.reference(types.union(
      Survey,
      SessionModel,
      QuestionModel,
      AnswerModel,
      SessionStepModel,
      FeatureModel,
    )),
    dataId: types.string,
  })
  .views(self => ({
    get maybeData(): IDataRef['data'] | undefined {
      const maybeData = tryReference(() => self?.data);
      return maybeData;
    },
    get survey(): ISurvey | undefined {
      if (self.type === 'SURVEY') {
        return this.maybeData as ISurvey | undefined;
      }
    },
    get session(): ISession | undefined {
      if (self.type === 'SESSION') {
        return this.maybeData as ISession | undefined;
      }
    },
    get question(): IQuestionModel | undefined {
      if (self.type === 'QUESTION') {
        return this.maybeData as IQuestionModel | undefined;
      }
    },
    get feature(): IFeature | undefined {
      if (self.type === 'FEATURE') {
        const rootStore = getRoot<IRootStore>(self);
        return rootStore.feature.getFeature(self.dataId) || undefined;
      }
    },
    get sessionStep(): ISessionStepModel | undefined {
      if (self.type === 'SESSION_STEP') {
        return  this.maybeData as ISessionStepModel | undefined;
      }
    },
    get exercise(): IExerciseModel | undefined {
      if (self.type === 'EXERCISE') {
        return this.maybeData as IExerciseModel | undefined;
      }
    }
  }));
export type IDataRef = Instance<typeof DataRef>;
